import { useEffect, useRef } from "react";
import { LogFirebase } from "../../../services/firestore";

export const useBeforeunload = (handler) => {
    const enabled = typeof handler === "function";

    // Persist handler in ref
    const handlerRef = useRef(handler);
    useEffect(() => {
        handlerRef.current = handler;
    });

    useEffect(() => {
        if (enabled) {
            const listener = (event) => {
                LogFirebase("_browser_window_close_clicked", "");
                const returnValue = handlerRef.current(event);

                if (typeof returnValue === "string") {
                    event.preventDefault();
                    // Handle legacy `event.returnValue` and `return` activation.
                    event.returnValue = returnValue; // Extracted assignment
                    return returnValue;
                }

                // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`.
                if (event.defaultPrevented) {
                    event.returnValue = ""; // Extracted assignment
                    return event.returnValue;
                }
            };

            window.addEventListener("beforeunload", listener);
            return () => {
                window.removeEventListener("beforeunload", listener);
            };
        }
    }, [enabled]);
};
